import React from 'react';
import { FormattedMessage } from 'react-intl';
import { AppState } from 'src/AppState';
import { reportError } from 'src/easyclaim.app.libs/reportError';
import styled from 'styled-components';

import { EasyClaimDocumentType } from '../easyclaim.api.client.typescript/src/index';
import { PlaceholderRearV2 } from '../easyclaim.app.assets/index';
import {
	DetailContainer,
	DetailsContainer,
	SelectImage,
	ImageFileInputType,
	StyledInfoIcon,
	ExampleModalImage,
} from '../easyclaim.app.components/index';
import { ImageSelectionService } from '../easyclaim.app.services';

import { ScreenComponent } from './ScreenComponent';

interface PolicyCheckVehicleImagesState {}

export class VehicleRearPerspectiveImageScreen extends ScreenComponent<
	AppState,
	PolicyCheckVehicleImagesState
> {
	constructor(props: AppState) {
		super(props);

		this.state = {};
		this.showVehicleRearPerspectiveImageExampleModal =
			this.showVehicleRearPerspectiveImageExampleModal.bind(this);
	}

	async showVehicleRearPerspectiveImageExampleModal() {
		const images: ExampleModalImage[] = [
			{
				src: `${process.env.PUBLIC_URL}/images/example-rear.jpg`,
			},
		];

		await this.props.showExampleModal(
			images,
			'vehicleImagesExampleModal.headline.first',
			'vehicleImagesExampleModal.button.close',
			'rear'
		);
	}

	public render() {
		return (
			<div className="main-container">
				<h2 className="vehicle-rear-perspective-title">
					<FormattedMessage id="vehicleImages.details.third" />
				</h2>
				<DetailsContainer>
					<DetailContainer>
						<Paragraph>
							<FormattedMessage id="vehicleImages.description" />{' '}
							<StyledInfoIcon
								onClick={() => {
									void this.showVehicleRearPerspectiveImageExampleModal().catch(
										(error: unknown) => {
											reportError(error, { context: 'VehicleRearPerspectiveImage.asyncAction' });
										}
									);
								}}
							/>
						</Paragraph>
						<SelectImage
							componentId="vehicleRear"
							imageFileInputType={ImageFileInputType.CapturePicture}
							fileType={EasyClaimDocumentType.RearPerspectivePicture}
							caseId={this.props.easyClaimCase?.caseId}
							easyClaimService={this.props.easyClaimService}
							currentImage={this.props.vehicleImageRear}
							title="vehicleImages.backOverview"
							placeholder={<StyledPlaceholderRear />}
							marginBottom="1rem"
							onChange={(image) => {
								const isImageLoading = ImageSelectionService.isImageLoading(image);

								const newState = Object.assign({}, this.props, {
									vehicleImageRear: image,
									isImageLoading: isImageLoading,
								});

								void this.props.setAppState(newState);
							}}
							onShowExample={() => {
								void this.showVehicleRearPerspectiveImageExampleModal().catch((error: unknown) => {
									reportError(error, {
										context:
											'VehicleRearPerspectiveImage.showVehicleRearPerspectiveImageExampleModal',
									});
								});
							}}
							showUserFeedbackInfo={true}
							configuration={this.props.easyClaimCase!._configuration!}
							inputError={this.props.inputError}
							canOverlayCamera={this.props.easyClaimCase?._configuration?.canShowOverlayOnCamera}
						/>
					</DetailContainer>
				</DetailsContainer>
			</div>
		);
	}
}

const StyledPlaceholderRear = styled(PlaceholderRearV2)`
	fill: ${(p) => p.theme.colors.primary};
	color: ${(p) => p.theme.colors.primary};
	background-color: white;
	width: auto;
	display: block;
	border-radius: 3px;
	opacity: 0.95;
`;

const Paragraph = styled.p`
	margin-bottom: 1rem;
	hyphens: auto;
	user-select: none;
	cursor: default;
`;
